import { autoinject } from "aurelia-framework";
import { BaseRangeRuleEditor } from "../base-range-rule-editor";
import { Api } from "../../../../services/api";
import { MdToastService } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";

@autoinject
export class ThingsNodeRuleEditor extends BaseRangeRuleEditor {

	constructor(api: Api, toastService: MdToastService, i18n: I18N) {
		super(api, toastService, i18n);
	}
}
